module.exports = __webpack_public_path__ + "static/media/choropleth.a7001f1a.png";